module.exports = __webpack_public_path__ + "static/media/dewart.a6bf778f.jpg";